export type PickImageResult = {
  file: File;
  dataUrl: string; 
  mimeType: string;
  extension: string;
};

function inferExtension(file: File): string {
  const fromName = file.name?.split(".").pop()?.toLowerCase() ?? "";
  if (fromName) return fromName;

  const fromMime = file.type?.split("/").pop()?.toLowerCase() ?? "";
  if (!fromMime) return "";
  return fromMime === "jpeg" ? "jpg" : fromMime;
}

export function fileToDataUrl(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(file);
  });
}

export async function pickImageFromGallery(): Promise<PickImageResult | null> {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = false;

    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return resolve(null);

      const dataUrl = await fileToDataUrl(file);
      resolve({
        file,
        dataUrl,
        mimeType: file.type || "",
        extension: inferExtension(file),
      });
    };

    input.click();
  });
}

